<template>
  <div
    class="main-content">
    <div class="row">
      <h2>ddd</h2>
    </div>
  </div>
</template>

<script>

  export default {

  }

</script>
